// Leaf module: server code reads it, so it must not import client modules.
export const MY_BIDS = 'my-bids';
